<template>
  <main-template>
    <v-row>
      <v-col>
        <h1>
          <v-btn
            color="primary"
            x-small
            text
            @click="() => $router.push({ name: 'usuarios' })"
            :disabled="submittingForm"
          >
            <v-icon left> fa fa-angle-left </v-icon>
          </v-btn>
          Recursos Humanos
        </h1>
      </v-col>
    </v-row>
    <ValidationObserver v-slot="{ handleSubmit }">
      <form
        @submit.prevent="handleSubmit(submitForm)"
        autocomplete="off"
        :disabled="submittingForm"
      >
        <v-row>
          <v-col cols="12">
            <h4>INFORMAÇÕES PESSOAIS</h4>
          </v-col>
          <v-col class="pt-0 pb-0" cols="8">
            <ValidationProvider name="Nome Completo" rules="required" v-slot="{ errors }">
              <e-label>Nome Completo</e-label>
              <v-text-field
                :error-messages="errors"
                v-model="form.pessoal.name"
                dense
                solo
                disabled
              />
            </ValidationProvider>
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Estado Civil</e-label>
            <e-autocomplete
              :items="$constants.estadosCivisList"
              :return-object="false"
              :item-value="(value) => value.id"
              :item-text="(value) => value.descricao"
              v-model="form.pessoal.estado_civil_id"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Sexo</e-label>
            <e-autocomplete
              :items="$constants.sexoList"
              :return-object="false"
              :item-value="(value) => value.id"
              :item-text="(value) => value.descricao"
              v-model="form.pessoal.sexo_id"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Cor/Raça</e-label>
            <e-autocomplete
              :items="$constants.corOuRacaList"
              :return-object="false"
              v-model="form.pessoal.cor_ou_raca"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>
          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Data de nascimento</e-label>
            <e-date-customize v-model="form.pessoal.data_nascimento" />
          </v-col>

          <v-col cols="12" class="pa-3">
            <v-divider></v-divider>
          </v-col>

          <v-col cols="12">
            <h4>PROFISSIONAL</h4>
          </v-col>

          <v-row class="pa-3" v-for="(profissional, index) in form.profissionais" :key="index">
            <v-col class="pt-0 pb-0" cols="8">
              <e-label style="font-weight: bold">Matrícula</e-label>
              <v-text-field
                v-model="profissional.matricula"
                dense
                solo
                v-mask="'#######################'"
              />
            </v-col>

            <v-col class="pt-0 pb-0" cols="4">
              <e-label>Regime trabalhista:</e-label>
              <e-autocomplete
                :items="$constants.regimeTrabalhistaList"
                :return-object="false"
                v-model="profissional.regime_trabalhista"
                label="Selecione uma opção"
                dense
                solo
              />
            </v-col>

            <v-col class="pt-0 pb-0" cols="4">
              <e-label>Cargo Concurso</e-label>
              <e-autocomplete
                :items="$constants.rolesParaRhList"
                :return-object="false"
                v-model="profissional.cargo_concurso"
                label="Selecione uma opção"
                dense
                solo
              />
            </v-col>

            <v-col class="pt-0 pb-0" cols="4">
              <e-label>Cargo em exercício</e-label>
              <e-autocomplete
                :items="$constants.rolesParaRhList"
                :return-object="false"
                v-model="profissional.cargo_exercicio"
                label="Selecione uma opção"
                dense
                solo
              />
            </v-col>

            <v-col class="pt-0 pb-0" cols="4">
              <e-label>Lotação</e-label>
              <e-autocomplete
                :items="franquiasList"
                :return-object="false"
                v-model="profissional.franquias_permitidas"
                :item-value="(franquia) => franquia.id"
                :item-text="(franquia) => franquia.descricao"
                :loading="carregandoFranquias"
                label="Selecione uma opção"
                dense
                multiple
                solo
              />
            </v-col>

            <v-col class="pt-0 pb-0" cols="4">
              <e-label>Data de ingresso</e-label>
              <e-date-customize v-model="profissional.data_ingresso" />
            </v-col>

            <v-col class="pt-0 pb-0" cols="4">
              <e-label>Carga horária total</e-label>
              <v-text-field v-model="profissional.ch_total" dense solo v-mask="'#####'" />
            </v-col>

            <v-col class="pt-0 pb-0" cols="4">
              <e-label>Turno de trabalho</e-label>
              <e-autocomplete
                :items="$constants.turnosList"
                :return-object="false"
                v-model="profissional.turno"
                label="Selecione uma opção"
                dense
                multiple
              />
            </v-col>
            <v-col cols="12" class="d-flex justify-space-between">
              <div class="d-flex">
                <v-btn
                  class="mt-2"
                  color="red"
                  dark
                  label="Remover"
                  @click="() => removerRelacaoProfissional(index)"
                  :disabled="submittingForm"
                >
                  Remover
                </v-btn>
              </div>
            </v-col>
          </v-row>
          <v-col cols="12" class="d-flex justify-space-between">
            <div class="d-flex">
              <v-btn
                class="mt-2"
                color="secondary"
                label="Selecione uma opção"
                @click="() => handleSubmit(adicionarRelacaoProfissional)"
                :disabled="submittingForm || !podeAdicionarMaisProfissionais"
              >
                Adicionar Mais Dados Profissionais
              </v-btn>
            </div>
          </v-col>

          <v-col cols="12" class="pa-3">
            <v-divider></v-divider>
          </v-col>

          <v-col cols="12">
            <h4>DOCUMENTOS</h4>
          </v-col>

          <v-col class="pt-0 pb-0" cols="6">
            <e-label>Número do CPF</e-label>
            <v-text-field v-mask="'###.###.###-##'" v-model="form.pessoal.cpf" dense solo />
          </v-col>

          <v-col class="pt-0 pb-0" cols="6">
            <e-label>Nº do Registro Geral</e-label>
            <v-text-field v-model="form.pessoal.rg" dense solo v-mask="'#############'" />
          </v-col>

          <v-col class="pt-0 pb-0" cols="6">
            <e-label>Email</e-label>
            <v-text-field v-model="form.pessoal.email" dense solo />
          </v-col>

          <v-col class="pt-0 pb-0" cols="6">
            <e-label>Telefone</e-label>
            <v-text-field v-model="form.pessoal.telefone" v-mask="'(##) #####-####'" dense solo />
          </v-col>

          <v-col cols="12" class="pa-3">
            <v-divider></v-divider>
          </v-col>

          <v-col cols="12">
            <h4>ENDEREÇO</h4>
          </v-col>

          <v-col class="pt-0 pb-0" cols="2">
            <e-label>Estado</e-label>
            <e-autocomplete
              :items="$constants.estadosList"
              :return-object="false"
              :item-text="(item) => item.codigo"
              :item-value="(item) => item.codigo"
              v-model="form.pessoal.uf_residencia"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>

          <v-col class="pt-0 pb-0" cols="3">
            <e-label> CEP </e-label>
            <v-text-field v-mask="'#####-###'" value="" v-model="form.pessoal.cep" dense solo />
          </v-col>

          <v-col class="pt-0 pb-0" cols="7">
            <e-label>Município</e-label>
            <v-text-field value="" v-model="form.pessoal.municipio_residencia" dense solo />
          </v-col>

          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Bairro</e-label>
            <v-text-field value="" v-model="form.pessoal.bairro_residencia" dense solo />
          </v-col>

          <v-col class="pt-0 pb-0" cols="4">
            <e-label>Rua</e-label>
            <v-text-field value="" v-model="form.pessoal.rua_residencia" dense solo />
          </v-col>

          <v-col class="pt-0 pb-0" cols="1">
            <e-label> Número </e-label>
            <v-text-field
              value=""
              v-model="form.pessoal.numero_residencia"
              dense
              solo
              v-mask="'########'"
            />
          </v-col>

          <v-col class="pt-0 pb-0" cols="3">
            <e-label>Complemento</e-label>
            <v-text-field value="" v-model="form.pessoal.complemento_residencia" dense solo />
          </v-col>

          <v-col cols="12" class="pa-3">
            <v-divider></v-divider>
          </v-col>

          <v-col cols="12">
            <h4>FORMAÇÃO</h4>
          </v-col>

          <v-col cols="12" v-for="(formacao, index) in form.formacoes" :key="index">
            <v-row>
              <v-col class="pt-0 pb-0" cols="6">
                <e-label>Área do curso</e-label>
                <e-autocomplete
                  :items="$constants.areaDoCursoList"
                  :return-object="false"
                  v-model="formacao.area_do_curso"
                  label="Selecione uma opção"
                  dense
                  solo
                />
              </v-col>

              <v-col class="pt-0 pb-0" cols="6">
                <e-label>Curso</e-label>
                <v-text-field v-model="formacao.curso" dense solo />
              </v-col>

              <v-col cols="12" class="d-flex justify-space-between">
                <v-btn
                  class="mt-2"
                  color="red"
                  dark
                  label="Remover"
                  @click="() => removerRelacaoFormacao(index)"
                  :disabled="submittingForm"
                >
                  Remover
                </v-btn>
              </v-col>
            </v-row>
          </v-col>

          <v-col cols="12" class="d-flex justify-space-between">
            <v-btn
              class="mt-2"
              color="secondary"
              @click="() => handleSubmit(adicionarRelacaoFormacao)"
              :disabled="submittingForm || !podeAdicionarMaisFormacoes"
            >
              Adicionar Mais Dados Formação
            </v-btn>
          </v-col>

          <v-col cols="12" class="pa-3">
            <v-divider></v-divider>
          </v-col>

          <v-col class="pt-0 pb-0" cols="7">
            <e-label>Maior Nível de Escolaridade Concluído</e-label>
            <e-autocomplete
              :items="$constants.nivelEscolaridadeConcluidoList"
              :return-object="false"
              v-model="form.pessoal.nivel_escolaridade_concluido"
              label="Selecione uma opção"
              dense
              solo
            />
          </v-col>

          <v-col cols="12" class="pa-3">
            <v-divider></v-divider>
          </v-col>

          <v-col class="mb-6" cols="12">
            <e-label>Documentos Anexados</e-label>
            <div class="dropboxStyles">
              <input
                id="fileUpload"
                class="input-file-upload"
                type="file"
                multiple
                @change="selectDocumento"
                style="display: none"
              />
              <span
                v-if="!documentosArray?.length && !pdfDocumentos?.length"
                style="cursor: pointer"
                >Uploads</span
              >

              <!-- Exibe mensagem se houver documentos em documentosArray -->
              <div v-if="documentosArray?.length" class="d-flex align-center mb-2">
                <v-chip class="ma-2" color="green" label text-color="white">
                  Você possui {{ documentosArray.length }} documento(s) anexado(s)
                </v-chip>
              </div>

              <!-- Lista documentosArray (se existir) -->
              <div
                v-for="(file, index) in documentosArray"
                :key="'doc-array-' + index"
                class="d-flex align-center mb-2"
              >
                <v-chip class="ma-2" color="green" label text-color="white">
                  {{ file.name || file.nomeArquivo || `Documento ${index + 1}` }}
                </v-chip>
                <v-btn class="mx-2" fab dark small color="red" @click="apagarDocumentoForm(index)">
                  <v-icon dark>mdi-trash-can</v-icon>
                </v-btn>
                <v-btn class="mx-2" fab dark small color="blue" @click="downloadDocumento(index)">
                  <v-icon dark>mdi-download</v-icon>
                </v-btn>
              </div>

              <!-- Lista pdfDocumentos (se existir) -->
              <div
                v-for="(file, index) in pdfDocumentos"
                :key="'pdf-' + index"
                class="d-flex align-center mb-2"
              >
                <v-chip class="ma-2" color="green" label text-color="white">
                  {{ file.name || file.nomeArquivo || `PDF ${index + 1}` }}
                </v-chip>
                <v-btn class="mx-2" fab dark small color="red" @click="apagarDocumento(file)">
                  <v-icon dark>mdi-trash-can</v-icon>
                </v-btn>
              </div>
            </div>
          </v-col>

          <v-col cols="6">
            <v-btn color="primary" @click="triggerFileInput" block> Incluir Documentos </v-btn>
          </v-col>
          <v-col cols="6">
            <v-btn
              color="green"
              block
              @click="() => gerarRelatorioDossie(form.pessoal.user_id, form.pessoal.rh_id)"
              >Gerar Dossiê</v-btn
            >
          </v-col>

          <v-col cols="12">
            <v-btn
              color="primary"
              :disabled="submittingForm"
              :loading="submittingForm"
              type="submit"
              block
              >Enviar Dados</v-btn
            >
          </v-col>
        </v-row>
      </form>
    </ValidationObserver>
  </main-template>
</template>

<script>
import ELabel from "../../components/ELabel.vue";

export default {
  components: { ELabel },
  props: {
    editing: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    documentosArray() {
      if (typeof this.form.pessoal.documento === "string") {
        return this.form.pessoal.documento.split(",");
      }
      return this.form.pessoal.documento;
    },
    podeAdicionarMaisProfissionais() {
      if (this.form.profissionais.length === 0) return true;

      const ultimoProfissional = this.form.profissionais[this.form.profissionais.length - 1];
      const camposObrigatorios = [
        "matricula",
        // 'regime_trabalhista',
        // 'cargo_concurso',
        // 'data_ingresso'
      ];
      return camposObrigatorios.every((campo) => ultimoProfissional[campo]);
    },
    podeAdicionarMaisFormacoes() {
      if (this.form.formacoes.length === 0) return true;

      const ultimoFormacao = this.form.formacoes[this.form.formacoes.length - 1];
      const camposObrigatorios = ["area_do_curso", "curso"];
      return camposObrigatorios.every((campo) => ultimoFormacao[campo]);
    },
  },
  mounted() {
    this.loadData();
  },
  data() {
    return {
      pdf: null,
      pdfDocumentos: [],
      submittingForm: false,
      form: { profissionais: {}, formacoes: {}, pessoal: {} },
      outrosRolesList: [],
      rolesList: [],
      usuarios: [],
      carregandoUsuarios: false,
      usuariosLoaded: false,
      usuariosList: [],
      carregandoFranquias: false,
      outrosUsuariosList: [],
    };
  },
  methods: {
    async submitForm() {
      this.submittingForm = true;
      const { usuario_id } = this.$route.params;
      this.form.pessoal.user_id = parseInt(usuario_id, 10);
      const payload = {
        user_id: parseInt(usuario_id, 10),
        ...this.form.pessoal,
        profissionais: this.form.profissionais,
        formacoes: this.form.formacoes,
      };

      try {
        await this.$services.recursosHumanosService.criarRecursosHumanos(payload);

        // Submeter os documentos

        if (this.pdfDocumentos && this.pdfDocumentos.length > 0 && usuario_id) {
          const formData = new FormData();
          this.pdfDocumentos.forEach((file, index) => {
            formData.append(`files[${index}]`, file);
          });

          await this.$services.recursosHumanosService.uploadDocumentos(formData, usuario_id);
        }

        /* ------------------------------------------------------------ */

        this.$toast.success("Usuario(a) criado(a) com sucesso");
        this.$router.push({ name: "usuarios" });
      } catch (error) {
        this.$handleError(error);
      }

      this.submittingForm = false;
    },

    async loadData() {
      try {
        this.carregandoFranquias = true;
        this.franquiasList = await this.$services.franquiasService.syncAll();

        const { usuario_id } = this.$route.params;
        const dadosUsuario = await this.$services.recursosHumanosService.getUsuario(usuario_id);
        const dadosRH = await this.$services.recursosHumanosService.getUsuarioRecursosHumanos(
          usuario_id
        );

        // Dados pessoais
        this.form.pessoal = {
          name: dadosUsuario.name,
          user_id: dadosRH.user_id,
          rh_id: dadosRH.id,
          estado_civil_id: dadosRH.estado_civil_id,
          sexo_id: dadosRH.sexo_id,
          cor_ou_raca: dadosRH.cor_ou_raca,
          data_nascimento: dadosRH.data_nascimento,
          cpf: dadosRH.cpf,
          rg: dadosRH.rg,
          email: dadosRH.email,
          telefone: dadosRH.telefone,
          uf_residencia: dadosRH.uf_residencia,
          cep: dadosRH.cep,
          municipio_residencia: dadosRH.municipio_residencia,
          bairro_residencia: dadosRH.bairro_residencia,
          rua_residencia: dadosRH.rua_residencia,
          numero_residencia: dadosRH.numero_residencia,
          complemento_residencia: dadosRH.complemento_residencia,
          area_do_curso: dadosRH.area_do_curso,
          curso: dadosRH.curso,
          nivel_escolaridade_concluido: dadosRH.nivel_escolaridade_concluido,
          documento: dadosRH.documento,
        };

        // Dados profissionais
        this.form.profissionais = [];

        // Percorre cada registro profissional
        if (dadosRH.profissionais?.length > 0) {
          dadosRH.profissionais.forEach((prof) => {
            const franquiasPermitidas = prof.franquias_permitidas
              ? JSON.parse(prof.franquias_permitidas)
              : [];

            const turno = prof.turno ? JSON.parse(prof.turno) : [];

            // Adiciona ao array de profissionais
            this.form.profissionais.push({
              matricula: prof.matricula,
              regime_trabalhista: prof.regime_trabalhista,
              cargo_concurso: prof.cargo_concurso,
              cargo_exercicio: prof.cargo_exercicio,
              franquias_permitidas: franquiasPermitidas,
              data_ingresso: prof.data_ingresso,
              ch_total: prof.ch_total,
              turno,
              id: prof.id, // Mantém o ID para referência
            });
          });
        }

        // Se não houver profissionais, cria um objeto vazio
        if (this.form.profissionais.length === 0) {
          this.form.profissionais.push({
            matricula: "",
            regime_trabalhista: "",
            cargo_concurso: "",
            cargo_exercicio: "",
            franquias_permitidas: [],
            data_ingresso: "",
            ch_total: "",
            turno: [],
          });
        }

        // Dados de formação
        this.form.formacoes = [];

        // Percorre cada registro de formação
        if (dadosRH.formacoes?.length > 0) {
          dadosRH.formacoes.forEach((formacao) => {
            // Adiciona ao array de formações
            this.form.formacoes.push({
              instituicao: formacao.instituicao,
              area_do_curso: formacao.area_do_curso,
              curso: formacao.curso,
              // nivel_escolaridade_concluido: formacao.nivel_escolaridade_concluido,
              ano_conclusao: formacao.ano_conclusao,
              id: formacao.id, // Mantém o ID para referência
            });
          });
        }

        // Se não houver formações, cria um objeto vazio
        if (this.form.formacoes.length === 0) {
          this.form.formacoes.push({
            instituicao: "",
            curso: "",
            nivel_escolaridade_concluido: "",
            ano_conclusao: "",
          });
        }

        this.$loaderService.close();
      } catch (error) {
        this.$handleError(error);
      } finally {
        this.carregandoFranquias = false;
      }
    },

    async adicionarRelacaoProfissional() {
      this.form.profissionais.push({
        matricula: "",
        regime_trabalhista: "",
        cargo_concurso: "",
        cargo_exercicio: "",
        franquias_permitidas: [],
        data_ingresso: "",
        ch_total: "",
        turno: [],
      });
    },

    async removerRelacaoProfissional(index) {
      const profissional = this.form.profissionais[index];

      if (this.form.profissionais.length < 2) {
        this.$toast.danger("É necessário cadastrar pelo menos uma relação profissional");
        return;
      }

      if (profissional.id) {
        try {
          this.submittingForm = true;
          await this.$services.recursosHumanosService.removerProfissional(profissional.id);
          this.$toast.success("Relação profissional removida com sucesso");
        } catch (error) {
          this.$handleError(error);
          return;
        } finally {
          this.submittingForm = false;
        }
      }

      this.form.profissionais.splice(index, 1);
    },

    async adicionarRelacaoFormacao() {
      this.form.formacoes.push({
        instituicao: "",
        area_do_curso: "",
        curso: "",
        // nivel_escolaridade_concluido: "",
        ano_conclusao: "",
      });
    },

    async removerRelacaoFormacao(index) {
      const formacao = this.form.formacoes[index];

      if (this.form.formacoes.length < 2) {
        this.$toast.danger("É necessário cadastrar pelo menos uma formação");
        return;
      }

      if (formacao.id) {
        try {
          this.submittingForm = true;
          await this.$services.recursosHumanosService.removerFormacao(formacao.id);
          this.$toast.success("Formação removida com sucesso");
        } catch (error) {
          this.$handleError(error);
          return;
        } finally {
          this.submittingForm = false;
        }
      }

      this.form.formacoes.splice(index, 1);
    },

    /* Metodos para apagar o documento selecionado */

    selectDocumento(event) {
      for (let i = 0; i < event.target.files.length; i++) {
        const file = event.target.files[i];
        if (file.type === "application/pdf") {
          this.pdfDocumentos.push(file);
        } else {
          this.$toast.danger(`Formato de arquivo inválido: ${file.name}`);
        }
      }
    },

    apagarDocumentoForm(index) {
      let documentos = this.form.pessoal.documento;

      if (typeof documentos === "string") {
        try {
          documentos = JSON.parse(documentos);
        } catch (e) {
          documentos = [];
        }
      }

      if (!Array.isArray(documentos)) {
        documentos = documentos ? [documentos] : [];
      }

      if (index >= 0 && index < documentos.length) {
        documentos.splice(index, 1);
      }

      this.$set(this.form.pessoal, "documento", documentos);

      if (documentos.length === 0) {
        document.querySelector("#fileUpload").value = "";
        this.pdf = null;
      }
    },

    apagarDocumento(documento) {
      const index = this.pdfDocumentos.findIndex((doc) => doc === documento);
      this.pdfDocumentos.splice(index, 1);
    },

    async downloadDocumento(file) {
      try {
        const { usuario_id } = this.$route.params;
        const data = await this.$services.recursosHumanosService.downloadDocumento(
          usuario_id,
          file
        );
        return data;
      } catch (error) {
        return this.$handleError(error);
      }
    },

    /* -------------- */

    async gerarRelatorioDossie(user_id, rh_id) {
      this.$loaderService.open("Carregando dados...");
      await this.$services.recursosHumanosService.gerarRelatorioDossie(
        parseInt(user_id, 10),
        parseInt(rh_id, 10)
      );
      this.$loaderService.close();
    },

    async triggerFileInput() {
      const fileInput = document.querySelector("#fileUpload");
      fileInput.click();
    },
  },
};
</script>

<style scoped>
.dropboxStyles {
  outline: 2px dashed grey;
  background-color: rgb(246, 255, 224);
  padding: 10px 10px;
  color: dimgray;
  cursor: pointer;
}
.input-file-upload {
  opacity: 0;
  width: 100%;
  height: 60px;
  position: absolute;
  cursor: pointer;
}
</style>
